import {MulticolumnListDirective} from "./directive/multicolumnListDirective";
import {MulticolumnListModule} from "./multicolumnListModuleConfiguration";

MulticolumnListModule
    .createNewModule()
    .directive('ngMulticolumnList', MulticolumnListDirective);